export default "__VITE_ASSET__CErV0FGV__"